export enum NotificationType {
    Email,
    Sms
}